module.exports = __webpack_public_path__ + "static/media/prev-arrow.bdfc0fe5.svg";